import { Navigate, Outlet, useLocation } from "react-router-dom";
import { LoadingState } from "../ui/DataState";
import { useAuth } from "../../contexts/AuthContext";
import type { Role } from "../../types/api";

export function ProtectedRoute({ role }: { role: Role }) {
  const auth = useAuth();
  const location = useLocation();
  if (!auth.ready)
    return (
      <main className="centered-page">
        <LoadingState label="Validando sua sessão…" />
      </main>
    );
  if (!auth.user)
    return (
      <Navigate
        to={role === "ADMIN" ? "/admin/entrar" : "/parceiro/entrar"}
        replace
        state={{ from: location }}
      />
    );
  if (auth.user.role !== role)
    return (
      <Navigate
        to={auth.user.role === "ADMIN" ? "/admin" : "/parceiro"}
        replace
      />
    );
  return <Outlet />;
}
